export default __webpack_public_path__ + "static/media/sugar1.4c00cb28.jpeg";